import React from 'react';
import { Grid } from '@mui/material';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import WatchedAdsChart from '../../components/reports/watched-ads-chart.component';

const AdsReportsOverviewView = () => {
  const pageTitle = PAGE_TITLE_LIST.REPORTS_OVERVIEW_ADS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <WatchedAdsChart />
        </Grid>
      </Grid>
    </AppLayout>
  );
};

export default AdsReportsOverviewView;
